import React from 'react';
import { MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Hi! I'm interested in your advertising services. I'd like to know more about your offerings."
    );
    const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl hover:scale-110 transition-all duration-300 z-50 flex items-center gap-2 group"
      aria-label="Contact on WhatsApp"
    >
      <MessageCircle size={28} className="animate-pulse" />
      <span className="hidden group-hover:inline-block text-sm font-semibold pr-2">
        Chat with us
      </span>
    </button>
  );
};
